const cidadesFrete = {
  SaoPaulo: [
    "São Paulo",
    "Guarulhos",
    "Osasco",
    "Santo André",
    "São Bernardo do Campo",
    "Maua",
    "Diadema",
    "Carapicuíba",
    "Taboão da Serra",
    "Itapecerica da Serra",
  ],
  BeloHorizonte: [
    "Belo Horizonte",
    "Contagem",
    "Betim",
    "Sabará",
    "Nova Lima",
    "Ribeirão das Neves",
    "Santa Luzia",
    "Ibirite",
    "Vespasiano",
    "São Jose da Lapa",
  ],
};

const promoBar = document.querySelector(".announcement-bar");
promoBar.innerHTML =
  "<span style='color: #FFF; text-align: center; display: block;'>CAFÉS ESPECIAIS - 100% ARÁBICA </span>";
let cidade;
let estado;

// Função para buscar IP
function getIp() {
  const ipLocation = sessionStorage.getItem("ipLocation");

  // Verificar se a localização está indefinida ou não foi definida ainda
  if (!ipLocation || ipLocation === "indefinida") {
    const urlIp = "https://pro.ip-api.com/json/?key=bBYnuEVV1ns1epI";

    try {
      fetch(urlIp, {
        "Content-Type": "application/json",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          cidade = data.city;
          estado = data.region;

          // Armazena os dados no sessionStorage
          sessionStorage.setItem("ipLocation", "definida");
          sessionStorage.setItem("cidade", cidade);
          sessionStorage.setItem("estado", estado);

          // Chama a função para atualizar a promoBar com os dados obtidos
          promoBarCidade(estado, cidade);
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });
    } catch (error) {
      console.error("Erro na API", error);
    }
  } else {
    // Se a localização já está definida, usar os valores do sessionStorage
    cidade = sessionStorage.getItem("cidade");
    estado = sessionStorage.getItem("estado");

    // Se já temos os dados da cidade e estado, chamamos a função promoBarCidade
    if (cidade && estado) {
      promoBarCidade(estado, cidade);
    } else {
      console.error(
        "Dados de cidade e estado não encontrados no sessionStorage"
      );
    }
  }
}

// Função para atualizar a barra de promoções
function promoBarCidade(estado, cidade) {
  if (estado === "MG") {
    if (cidadesFrete.BeloHorizonte.indexOf(cidade) > -1) {
      promoBar.innerHTML =
        "<center><span style='color: #FFF'> <strong>FRETE GRÁTIS</strong> → BH e SP Capital acima de R$99,90 🚚</span></center>";
      sessionStorage.setItem("freteGratis", "true");
    }
  } else if (estado === "SP") {
    if (cidadesFrete.SaoPaulo.indexOf(cidade) > -1) {
      promoBar.innerHTML =
        "<center><span style='color: #FFF'> <strong>FRETE GRÁTIS</strong> → SP Capital e BH acima de R$99,90 🚚 </span></center>";
      sessionStorage.setItem("freteGratis", "true");
    }
  } else {
    promoBar.innerHTML =
      "<span style='color: #FFF'>CAFÉS ESPECIAIS - 100% ARÁBICA</span>";
  }
}

// Chama a função getIp para verificar ou buscar a localização
getIp();
